import { knowledgeBaseArticle } from "@/types/main";
import { ApiWrapper } from "../types/main";
import { apiCall, http } from "./http";

export async function getArticle(id: string) {
    const url = `knowledgeBase/article`;
    const res = apiCall<knowledgeBaseArticle>(() => http.get(url.toString(), { searchParams: { id } }));
    return res;
}
